export default "__VITE_ASSET__BY_CZ3j8__"